<template>
 <div class="info-wrapper">
    <div class="title">{{title}}</div>
    <div v-if='!content || (content && content.length<24)' class='desc cursor1'>
      {{content||"--"}}
    </div>
    <el-tooltip v-else class="item" effect="dark" :content="content" placement="top-start">
      <div class="desc cursor2">{{content.slice(0,24)}}...</div>
    </el-tooltip>
  </div>
</template>

<script>
export default{
  props:{
    title:{
      type:String,
      default:''
    },
    content:{
      type:String,
      default:''
    }
  },
  data(){
    return{

    }
  },
}
</script>

<style lang='less' scoped>
.info-wrapper{
  display: flex;
  justify-content: space-between;
  line-height: 26px;
}
.title{
  color: #646566 !important;
  font-weight: 400!important;
}
.cursor2{
   cursor: pointer;
}
.desc{
  color: #323233!important;
  font-weight: 400!important;
  // max-width: 212px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.line {
  border-top: 1px solid gray;
  margin: 12px 0;
  padding-top: 20px;
  font-weight: bold;
  font-size: 16px;
}
.basic {
  padding-bottom: 20px;
  font-weight: bold;
  font-size: 16px;
}
</style>
